/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48168Req {
  
  /** 商业计划书编号 */
  planNo?: string;
  /** 审批结果草稿=0待评估=10不通过=20通过=30; */
  bizPlanStatus?: number;
  /** 项目等级S+=1S=2A=3B=4 */
  level?: number;
};



export type API48168Res = {};


// 48168 审核商业计划书

export interface IUsePostAPI48168Return {
  /** 审核商业计划书: 接口请求状态 */
  isAPI48168Loading: boolean;
  /** 审核商业计划书: 接口请求返回数据 */
  dataAPI48168: API48168Res;
  /**  审核商业计划书: 接口数据请求方法 */
  fetchAPI48168Data:  (inputs: API48168Req, config?: YWRequestConfig) => Promise<API48168Res>;
  /** 审核商业计划书: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48168 = ():IUsePostAPI48168Return => {
  let isMount = true;
  const [isAPI48168Loading, setIsAPI48168Loading] = useState(false);
  const [dataAPI48168, setDataAPI48168] = useState<API48168Res>({} as API48168Res);
  const requestUrl = `${basePath}/corp-admin/project/plan4biz/audit`;

  const fetchAPI48168Data = async (inputs: API48168Req, config?: YWRequestConfig): Promise<API48168Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48168Req>) || {}) as API48168Req;
    
  
    if ( isMount ) {
      setIsAPI48168Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48168Res>(`${basePath}/corp-admin/project/plan4biz/audit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48168(res || {} as API48168Res);
        setIsAPI48168Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48168Loading(false);
      }
      return false as unknown as API48168Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48168Loading,
    dataAPI48168,
    fetchAPI48168Data,
    requestUrl,
  }
}

